import { useSelector } from 'react-redux';
import { getX50TotalSum, getMembers } from '../selectors';
import { IStore } from 'store/interface';

export const useMembers = () => ({
  totalSum: useSelector<IStore, IStore['x50']['totalSum']>(getX50TotalSum),
  members: useSelector<IStore, IStore['x50']['members']>(getMembers),
});
